// import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
// import { Spin } from "antd";
// import { toastError } from "../../helpers/toasters";
// import { getMerchantLogos, getMerchatTypes } from "../../network";
// import {
//   merchant1,
//   merchant2,
//   merchant3,
//   merchant4,
//   merchant5,
//   merchant6,
//   merchant7,
//   merchant8,
//   merchant9,
//   merchant10,
//   merchant11,
//   merchant12,
// } from "../../assets/images/merchant";

// // components
// import TypeCard from "./TypeCard";
// import SellModal from "./SellModal";
// import EmptyState from "../BuyAndSupply/EmptyState";
// import { baseUrl } from "../../services";

// const Merchant = () => {
//   const [merchantLogos, setMerchantLogos] = useState([]);
//   const [data, setData] = useState(null);
//   const [selectedType, setSelectedType] = useState(null);
//   const [openSellModal, setOpenSellModal] = useState(false);
//   const [renderMe, setRenderMe] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const { dir } = useSelector((state) => state.language);
//   const { t } = useTranslation();
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const handleCancelSellModal = () => {
//     setOpenSellModal(false);
//     setSelectedType(null);
//   };

//   const handleOpenSellModal = (type) => {
//     setSelectedType(type);
//     setOpenSellModal(true);
//   };

//   useEffect(() => {
//     setLoading(true);
//     getMerchatTypes(
//       (res) => {
//         setLoading(false);
//         if (res.success) {
//           setData(res.data);
//         } else {
//           toastError(res.message);
//         }
//       },
//       (res) => {
//         setLoading(false);
//         toastError(res?.data?.error);
//       }
//     );
//   }, [dir, renderMe]);

//   useEffect(() => {
//     getMerchantLogos(
//       (success) => {
//         setMerchantLogos(success.data);
//       },
//       (error) => {
//         toastError(error.message || "An error occurred");
//       }
//     );
//   }, []);

//   const chunkArray = (arr, size) => {
//     const result = [];
//     for (let i = 0; i < arr.length; i += size) {
//       result.push(arr.slice(i, i + size));
//     }
//     return result;
//   };

//   const logoChunks = chunkArray(merchantLogos, 4);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % logoChunks.length);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [logoChunks.length]);

//   return (
//     <section dir={dir} className="merchant">
//       <header className="merchant__header d-flex justify-content-center align-items-center">
//         <div>
//           <h1 className="text-center green-text fsize-1 ">
//             {t("nav.merchant")}
//           </h1>
//           <p className="mb-0 fw-500 text-white fsize-6 text-center">
//             {t("merchant.description")}
//           </p>
//         </div>
//       </header>
//       <Spin size="large" className="w-100" spinning={loading}>
//         {data ? (
//           data.length > 0 ? (
//             <div className="merchant__types">
//               <div
//                 dir="ltr"
//                 className="row justify-content-center justify-content-lg-start m-0"
//               >
//                 {data?.map((type, indx) => {
//                   return (
//                     <div
//                       key={type.id}
//                       className={`col-sm-8 col-md-12 col-lg-6 ${
//                         indx % 2 === 0 ? "ps-lg-0" : "pe-lg-0"
//                       }`}
//                     >
//                       <TypeCard data={type} onSell={handleOpenSellModal} />
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           ) : (
//             <EmptyState mode="" data={"items"} />
//           )
//         ) : (
//           ""
//         )}

//         {/* <div className="merchant__image-container">
//           <div
//             className="slider-track"
//             style={{
//               transform: `translateX(-${currentSlide * 100}%)`,
//             }}
//           >
//             {logoChunks.map((group, groupIdx) => (
//               <div className="logo-group" key={groupIdx}>
//                 {group.map((logo, i) => {
//                   return (
//                     <img
//                       key={i}
//                       src={baseUrl + logo.logo}
//                       alt={`Merchant ${groupIdx * 4 + i + 1}`}
//                       loading="lazy"
//                     />
//                   );
//                 })}
//               </div>
//             ))}
//           </div>
//         </div> */}

//         <div className="merchant__image-container">
//           {merchantLogos?.map((logo, index) => {
//             return (
//               <img
//                 //   className={
//                 //     [7, 3].includes(logo.id) ? "paymob" : undefined
//                 //   }
//                 // src={baseUrl + logo.logo}
//                 // key={logo.id}
//                 key={logo.id}
//                 src={baseUrl + logo.logo}
//                 alt="partner-logo"
//                 loading="lazy"
//               />
//             );
//           })}
//         </div>
//       </Spin>
//       {openSellModal && (
//         <SellModal
//           open={openSellModal}
//           selectedType={selectedType}
//           onCancel={handleCancelSellModal}
//           onSubmit={() => {
//             setRenderMe(!renderMe);
//             handleCancelSellModal();
//           }}
//         />
//       )}
//     </section>
//   );
// };

// export default Merchant;

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getMerchantLogos } from "../../network";
import { toastError } from "../../helpers/toasters";
import { baseUrl } from "../../services";

export default function Merchant() {
  const [merchantLogos, setMerchantLogos] = useState([]);

  const { dir } = useSelector((state) => state.language);
  const { t } = useTranslation();

  useEffect(() => {
    getMerchantLogos(
      (success) => {
        setMerchantLogos(success.data);
      },
      (error) => {
        toastError(error.message || "An error occurred");
      }
    );
  }, []);

  return (
    <section dir={dir} className="merchant">
      <header className="merchant__header d-flex justify-content-center align-items-center">
        <div>
          <h1 className="text-center green-text">{t("nav.merchant")}</h1>
          <p className="mb-0 fw-500 text-white text-center">
            {t("merchant.description")}
          </p>
        </div>
      </header>

      <div className="merchant__image-container">
        {merchantLogos?.map((logo) => {
          return (
            <img
              className={[7, 3].includes(logo.id) ? "paymob" : undefined}
              src={baseUrl + logo.logo}
              key={logo.id}
              alt="partner-logo"
              loading="lazy"
            />
          );
        })}
      </div>
    </section>
  );
}
